import { ArrowRightIcon } from '@phosphor-icons/react';
import { PillButton } from '@/components/kit';
import type { PublicBooking } from '@/lib/api/schemas';
import { BookingStatusCard } from '../BookingStatusCard';
import { ReminderActions } from '../ReminderActions';

interface DoneStepProps {
  booking: PublicBooking;
  token: string;
  onOpenMy: () => void;
  onClose: () => void;
}

export function DoneStep({ booking, token, onOpenMy, onClose }: DoneStepProps) {
  return (
    <div className="ui-stack" style={{ ['--ui-gap' as string]: 'var(--spacing-4)' }}>
      <BookingStatusCard booking={booking} />
      <ReminderActions booking={booking} token={token} />
      <p className="ui-caption">Запись сохранена на этом устройстве — её можно открыть в разделе «Моя запись» и отменить.</p>
      <PillButton variant="primary" size="lg" block endIcon={ArrowRightIcon} onClick={onOpenMy}>
        Моя запись
      </PillButton>
      <PillButton variant="ghost" block onClick={onClose}>
        Готово
      </PillButton>
    </div>
  );
}
